import { Link, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { callApi } from "../../../ApiHelper/ApiHelper";
import EditIcon from "../../../components/Icons/EditIcon";
import PlusIcon from "../../../components/Icons/PlusIcon";
import { apiUrl } from "../../../ApiHelper/ApiUrl";

import MainHeading from "../../../components/comman/MainHeading";
import AddExpenseHeadModal from "./AddExpenseHeadModal";
import CommonTable from "../../../components/comman/CommonTable";
import FilterComponent from "../../../components/comman/FilterComponent";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import { useDispatch, useSelector } from "react-redux";
import { updateFiltersStates } from "../../../store/actions/UserActions";

export default function ExpenseHead() {
  const timeoutId = useRef(null);
  const dispatch = useDispatch();
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const userDetails = useSelector((state) => state.root.userDetails);
  const [expenseModal, setExpenseModal] = useState(false);
  const toggleExpenseModal = () => setExpenseModal(!expenseModal);
  const [modalData, setModalData] = useState({});
  const [pageStates, setPageStates] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    CustomerData: [],
    searchQuery: "",
    type: "Supply"
  });

  useEffect(() => {
    GetExpenseHeadList(pageStates?.currentPage);
  }, [pageStates?.currentPage, pageStates?.searchQuery, pageStates?.pageSize, filterDetails?.orderBy]);

  const GetExpenseHeadList = () => {
    let options = {
      method: "GET",
    };
    let API =
      apiUrl.get_expense_head + "?" + MainFilterHandler({ ...pageStates, orderBy: filterDetails?.orderBy });
    setPageStates((prev) => ({
      ...prev,
      tableLoader: true,
      CustomerData: {},
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
      if (response?.status === true) {
        const newData = response?.data?.expenseHead?.map((item) => ({
          ...item,
          expenseHeadType: item?.expenseheadtype?.name,
          toggleStatus: item?.isActive,
        }));
        setPageStates((prevStates) => ({
          ...prevStates,
          CustomerData: newData,
          count: response?.data?.pageInfo?.total,
          totalPages: response?.data?.pageInfo?.totalPages,
        }));
      }
    });
  };

  const PageChangeHandler = (PageNo) => {
    if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
      setPageStates((prev) => ({
        ...prev,
        currentPage: PageNo,
      }));
    }
  };

  const handleChangePageSize = (value) => {
    setPageStates((prev) => ({
      ...prev,
      pageSize: value,
      currentPage: 1
    }));
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      setPageStates((prevState) => ({
        ...prevState,
        currentPage: 1,
        searchQuery: value,
      }));
    }, 300);
  };

  const HandleUpdate = (data) => {
    setModalData(data)
    toggleExpenseModal();
  };


  const handleStatusToggle = (data, isActive) => {
    let submitData = {};
    submitData = {
      isActive: isActive ? 0 : 1
    }
    const options = {
      method: "POST",
      data: submitData,
    };
    let API =
      apiUrl?.update_expense_head + `?expenseHeadId=${data?.id}`;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        toast.success(response?.message);
        GetExpenseHeadList(pageStates?.currentPage);
      } else {
        toast.error(response?.message);
      }
    });
  }

  const TableHeading = [
    { value: "index", label: "SR NO." },
    { value: "name", label: "Expense Head Name" },
    { value: "toggleStatus", label: "Status" },
  ];

  const ActionData = [
    {
      label: "Edit",
      className: "btn btn-link",
      icon: <EditIcon />,
      title: "edit",
      clickHandler: HandleUpdate,
    }
  ];

  const orderByHandler = (e) => {
    dispatch(
      updateFiltersStates({
        orderBy: e.target.value,
      })
    );
  };

  const orderByList = [
    { value: "", name: "Newest" },
    { value: "asc", name: "Oldest" },
  ];

  return (
    <>
      <>
        <div className="content">
          <MainHeading
            title={"Supply Expense Head"}
            buttonText={userDetails?.type == 2 ? "Add Expense Head" : ""}
            buttonIcon={userDetails?.type == 2 ? <PlusIcon /> : ""}
            // buttonLink={RoutesLink?.add_customer}
            clickHandler={userDetails?.type == 2 ? toggleExpenseModal : undefined}
          />
          <div className="card mb-4">
            <div className="card-body">
              <FilterComponent
                handleSearch={handleSearchChange}
                orderByHandler={orderByHandler}
                orderByList={orderByList}
              />
              <CommonTable
                TableHeading={TableHeading}
                TableData={pageStates?.CustomerData}
                ActionData={userDetails?.type == 2 ? ActionData : ""}
                currentPage={pageStates?.currentPage}
                PageChangeHandler={PageChangeHandler}
                isLoading={pageStates?.tableLoader}
                totalPages={pageStates?.totalPages}
                count={pageStates?.count}
                handleStatusToggle={userDetails?.type == 2 ? handleStatusToggle : () => { toast.error("You don't have permission to perform this action") }}
                handleChangePageSize={handleChangePageSize}
                pageSize={pageStates.pageSize}
              />
            </div>
          </div>
        </div>
      </>
      <AddExpenseHeadModal
        modal={expenseModal}
        toggle={toggleExpenseModal}
        GetExpenseHeadList={GetExpenseHeadList}
        modalData={modalData}
        setModalData={setModalData}
      />
    </>
  );
}
